/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import Tysiav2LedgerFilterClaims from 'DesignSystem/Svgs/Tysiav2LedgerFilterClaims/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/Charge"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
let entryValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
format: fromHelpers.getAmount,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsRed800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.800'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let constantData = 'added on '
let entryCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_at',
format: fromFormat.dateShortWithMonth,
})
let constantData1 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, entryCreatedAtValueData, constantData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let entryValueData1 = fromData.useDataFormat({ viewPath,
context: 'entry',
format: fromHelpers.getDescription,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Charge.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Charge.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-2nG5Pd': dtColorsGreen200,'--mt-6-2nG5Pd': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2PlusIcon
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 fill2={dtColorsGreen900}
 width={6}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 data="entry"
 format="helpers.js getAmount"
 text={entryValueData}
/>
<div
  data-testid="Charge.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-7-2nG5Pd': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-8-2nG5Pd': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Charge.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="red"
 style="filled"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2LedgerFilterClaims
{...childProps}
  viewPath={`${viewPath}/Tysiav2LedgerFilterClaims`}
 fill={dtColorsRed800}
 stroke={dtColorsRed200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Charge"
/>
</React.Fragment>
)}
</TysiaTag>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="'added on '"
 data="entry.created_at"
 format="/Data/format.js dateShortWithMonth"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
<div
  data-testid="Charge.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-8-2nG5Pd': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 data="entry"
 format="helpers.js getDescription"
 text={entryValueData1}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}